module.exports = __webpack_public_path__ + "static/media/share-24px.34270c56.svg";